import script from "./Snack_Bar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Snack_Bar.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__